// @ts-nocheck
import { curry, pathOr } from "ramda"
import { convertPath } from "."

export const getDeepNestedValue = curry((myPath, data) => {
  const path = convertPath(myPath, data)
  if (path.includes(-1)) return null
  return pathOr(null, path, data)
})
